<template>
    <div>
        <div class="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div class="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <div v-for="(email, index) in values" :key="index">
                    <div class='d-flex justify-content-between align-items-center mb-2'>
                        <p>{{ email.value }} {{ email.default ? '(Default)' : '' }}</p>
                        <button
                            type='button' 
                            className='btn btn-icon btn-outline-danger' 
                            :style="{ background: 'none !important', border: 'none !important', cursor: 'pointer !important'}"
                        >   

                            <i 
                                v-if="!email.default"
                                class='fa fa-bell text-primary mr-2'
                                :style="{fontSize: '1.2rem'}"
                                @click="setAsDefault(email, true)"
                            >
                            </i>
                            <i 
                                v-if="email.default"
                                class='fa fa-bell-slash text-primary mr-2'
                                :style="{fontSize: '1.2rem'}"
                                @click="setAsDefault(email, false)"
                            ></i>
                            <i 
                                class='fa fa-pencil text-primary mr-2'
                                :style="{fontSize: '1.2rem'}"
                                @click="editing = email; value = email.value"
                            >
                            </i>
                            <i 
                                class='fa fa-trash text-danger'
                                :style="{fontSize: '1.2rem'}"
                                @click="removeValue(email.id)" 
                            >
                            </i>
                        </button>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                    <div class="form-group">
                        <label for="value">Value</label>
                        <div class="input-group">
                            <input v-model="value" class="form-control" type="email">
                            <div class="input-group-append" v-if="editing">
                                <button class="btn btn-light btn-border" type="button" @click="clear">Clear</button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="pt-3">
                    <button @click="update" type="button" class="btn btn-primary mr-2" :disabled="!isValidEmail(value)" >
                        {{ editing ? 'Update' : 'Add' }}
                    </button>
                    <button @click="close(values)" type="button" class="btn btn-danger mr-2">
                        Close
                    </button>
                </div>

                <small>
                    By default all notifications goes to the primary email, you can create an additional email 
                    here and set as default for notifications by clicking the bell icon beside the email you want to use
                </small>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AdditionalEmailsModal',
        props: ['close', 'emails'],
        data() {
            return {
                values: this.emails,
                editing: null,
                value: ''
            }
        },

        methods: {
            removeValue(email_id) {
                this.values = this.values.filter(item => item.id != email_id);
            },

            clear() {
                this.editing = null,
                this.value = ''
            },

            update() {
                if (this.editing) {
                    this.values = this.values.map(email => {
                        if (email.id == this.editing.id) {
                            return {
                                id: this.editing.id,
                                value: this.value,
                                default: this.editing.default
                            }
                        }
                        return email
                    })
                } else {
                    this.values.push({
                        id: this.values.length + 1,
                        value: this.value,
                        default: false,
                    });
                }

                this.value = ''
                this.editing = false
            },

            isValidEmail(email) {
                if (!email || email.length < 1) return false
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
                return emailRegex.test(email);
            },

            setAsDefault(email, action) {
                this.values = this.values.map(val => {
                    if (val.id == email.id) {
                        return {
                            id: email.id,
                            value: email.value,
                            default: action
                        }
                    }

                    return {
                        id: val.id,
                        value: val.value,
                        default: false
                    }
                })
            }
        }
    }
</script>